/**
 * Searchanise Hybrid Redirect - Targeted
 * Intercept: Popular Suggestions klik + "VIEW ALL X ITEMS" button
 * Redirect ke: Shopify native /search?q=...&type=product
 */

(function () {
  'use strict';

  function redirectToSearch(query) {
    if (!query || !query.trim()) return;
    window.location.href = '/search?q=' + encodeURIComponent(query.trim()) + '&type=product';
  }

  function getActiveQuery() {
    var inputs = document.querySelectorAll(
      '#snize-search-box, .snize-input, input.snize-search-field, ' +
      '[data-predictive-search-input], input[name="q"]'
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value && inputs[i].value.trim()) {
        return inputs[i].value.trim();
      }
    }
    return '';
  }

  document.addEventListener('click', function (e) {
    var target = e.target;

    // ── 1. Popular Suggestions item ──
    var suggestionLink =
      target.closest('.snize-suggestion') ||
      target.closest('.snize-autocomplete-suggestion') ||
      target.closest('[class*="snize-suggest"]') ||
      target.closest('.snize-popular-query') ||
      target.closest('[class*="snize-popular"]') ||
      target.closest('[class*="snize-query"]');

    if (suggestionLink) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var queryText = suggestionLink.textContent.trim();
      var linkEl = suggestionLink.querySelector('a') || (suggestionLink.tagName === 'A' ? suggestionLink : null);
      var href = linkEl ? linkEl.href : '';
      if (href && href.includes('q=')) {
        var urlParams = new URLSearchParams(href.split('?')[1]);
        queryText = urlParams.get('q') || queryText;
      }

      redirectToSearch(queryText || getActiveQuery());
      return;
    }

    // ── 2. "VIEW ALL X ITEMS" button ──
    var viewAllBtn =
      target.closest('.snize-view-all-results') ||
      target.closest('[class*="snize-view-all"]') ||
      target.closest('[class*="snize-show-all"]') ||
      target.closest('[class*="snize-see-all"]') ||
      target.closest('.snize-footer') ||
      target.closest('[data-predictive-search-results] .btn');

    if (viewAllBtn) {
      var btnEl = viewAllBtn.tagName === 'A' ? viewAllBtn : viewAllBtn.querySelector('a');
      var btnHref = btnEl ? btnEl.href : '';
      if (btnHref && btnHref.includes('/search') && !btnHref.includes('pages/search-results')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var q = getActiveQuery();
      if (!q && btnHref && btnHref.includes('q=')) {
        var p = new URLSearchParams(btnHref.split('?')[1]);
        q = p.get('q') || p.get('query') || '';
      }
      redirectToSearch(q);
      return;
    }

    // ── 3. Fallback: any link ke /pages/search-results ──
    var anyLink = target.closest('a[href*="pages/search-results"]');
    if (anyLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var params = new URLSearchParams(anyLink.href.split('?')[1] || '');
      redirectToSearch(params.get('q') || params.get('query') || getActiveQuery());
    }

  }, true);

  // ── 4. Intercept form submit Searchanise ──
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!action.includes('pages/search-results') && !action.includes('snize')) return;
    e.preventDefault();
    var qEl = form.querySelector('input[name="q"], #snize-search-box, .snize-input');
    redirectToSearch(qEl ? qEl.value : getActiveQuery());
  }, true);

  // ── 5. Auto redirect jika landing di /pages/search-results ──
  (function () {
    if (window.location.pathname.includes('pages/search-results')) {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q') || params.get('query') || '';
      if (q) redirectToSearch(q);
    }
  })();

  // ── DEBUG: uncomment untuk cari selector yang exact ──
  // document.addEventListener('click', function(e) {
  //   var el = e.target; var chain = [];
  //   while(el && el !== document.body) {
  //     chain.push(el.tagName + (el.className ? '.' + [...el.classList].join('.') : '') + (el.id ? '#' + el.id : ''));
  //     el = el.parentElement;
  //   }
  //   console.log('[SNIZE DEBUG]', chain.join(' > '));
  // }, true);

})();
